import { flex } from '@onbeam/business-styled-system/patterns';
import { NavItem } from './NavItem';
import NextLink from 'next/link';
import { center } from '@onbeam/business-styled-system/patterns';
import { css, cx } from '@onbeam/business-styled-system/css';
import { MobileNavigationButton } from './MobileNavigationButton';
import { navItems } from './Header.utils';
import { BeamFoundationLogo } from '@/icons/custom';
import { Button } from '@onbeam/business-ui';
import { HeaderProps } from './Header.types';
import { FormProgressPingContainer } from './FormProgressPingContainer';

export const Header = ({
  as: As = 'header',
  className,
  css: cssProp,
  children,
  isEmpty,
  ...props
}: HeaderProps) => (
  <As
    className={cx(
      css(
        flex.raw({
          w: 'full',
          pos: 'relative',
          justify: 'space-between',
          align: 'center',
          maxW: '[90rem]',
          mx: 'auto',
          px: '6',
          py: '5',
          gap: '2',
          zIndex: 10,
          color: 'mono.primaryBg',
          xl: {
            py: '8',
            px: '10',
          },
        }),
        cssProp,
      ),
      className,
    )}
    {...props}
  >
    <NextLink href="/">
      <BeamFoundationLogo
        className={css({
          mb: '0.5',
          '@media(max-width: 26.25rem)': {
            w: 'full',
          },
        })}
      />
      <span className={css({ srOnly: true })}>Home</span>
    </NextLink>
    {children}
    {!isEmpty && (
      <>
        <div
          className={center({
            position: 'absolute',
            inset: '0',
            pointerEvents: 'none',
            mdDown: { display: 'none' },
          })}
        >
          <nav
            className={flex({
              textStyle: 'body-sm',
              gap: '5',
              smDown: {
                display: 'none',
              },
            })}
          >
            {navItems.map((item) => (
              <NavItem {...item} key={item.label} />
            ))}
          </nav>
        </div>
        <FormProgressPingContainer
          className={css({ mdDown: { display: 'none' } })}
        >
          <Button as={NextLink} href="/apply">
            Apply for grant
          </Button>
        </FormProgressPingContainer>
        <FormProgressPingContainer className={css({ md: { display: 'none' } })}>
          <MobileNavigationButton />
        </FormProgressPingContainer>
      </>
    )}
  </As>
);
